<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>account_balance</mat-icon></div>
    <div class="cpf-header-text">
      <h2 class="cf-dlg-title">{{ isEdit ? 'Editar póliza de crédito' : 'Nueva póliza de crédito' }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando póliza de crédito…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Actualizando póliza…' : 'Creando póliza…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch">
        <mat-icon>error</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <form class="cpf-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <span class="cf-dlg-section__label">Entidad bancaria</span>

        <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('banco')">
          <app-autocomplete [control]="form.controls.banco" [config]="bancoConfig"></app-autocomplete>
        </div>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('bic')">
            <app-autocomplete [control]="form.controls.bic" [config]="bicConfig"></app-autocomplete>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('limite')">
            <app-field [control]="form.controls.limite" [config]="limiteConfig"></app-field>
          </div>
        </div>

        <div class="cf-field--required" [class.cf-field--invalid]="isInvalid('iban')">
          <app-field [control]="form.controls.iban" [config]="ibanConfig"></app-field>
        </div>

        <div class="cpf-uid" *ngIf="entity?.uid">
          <button type="button" class="cpf-link" (click)="showUid = !showUid">
            <mat-icon>{{ showUid ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showUid ? 'Ocultar UID' : 'Ver UID' }}
          </button>
          <span class="cpf-uid__value" *ngIf="showUid">{{ entity?.uid }}</span>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary" [disabled]="saving">
          <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear póliza' }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
